import axios from "axios";
import { getHeaders } from "../utils/main";
import endpoints from "./endpoints";


export const fetchUsageTimeApi = async (params) => {
    const callResponse = await axios({
      url: endpoints.fetchUsageTime,
      method: "get",
      headers: getHeaders(),
      params,
    })
      .then((response) => response.data)
      .catch((err) => ({status:0,response:err.response,code:err.response.status}));
  
    return callResponse;
  };
  
  export const fetchDailyUsageTimeApi = async (params) => {
    const callResponse = await axios({
      url: endpoints.fetchDailyUsageTime,
      method: "get",
      headers: getHeaders(),
      params,
    })
      .then((response) => response.data)
      .catch((err) => ({status:0,response:err.response,code:err.response.status}));
  
    return callResponse;
  };


  export const fetchUsageTimeByTherapyApi = async (params) => {
    const callResponse = await axios({
      url: endpoints.fetchUsageTimeByTherapy,
      method: "get",
      headers: getHeaders(),
      params,
    })
    .then((response) => response.data)
    .catch((err) => ({status:0,response:err.response,code:err.response.status}));

  return callResponse;
};